/** @format */

import {ReactNode} from 'react';

import {MenuItem, Checkbox, Box} from '@mui/material';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import {
  StyledFormControl,
  StyledSelect,
  StyledMenuItem,
  StyledCheckbox,
  StyledPlaceholderMenuItem,
  StyledMenuItemText,
  MENU_PROPS,
} from './styles';
import type {SelectFieldProps} from './types';
import FieldLabelWithHelp from './FieldLabelWithHelp';

const SingleSelect = ({
  value,
  label,
  onChange,
  options,
  placeholder = 'Выбрать',
  disabled = false,
}: SelectFieldProps) => {
  return (
    <Box>
      <FieldLabelWithHelp label={label} />
      <StyledFormControl fullWidth>
        <StyledSelect
          value={value}
          onChange={onChange}
          IconComponent={ArrowDropDownIcon}
          MenuProps={MENU_PROPS}
          displayEmpty
          disabled={disabled}
          renderValue={(selected): ReactNode => {
            if (!selected) {
              return placeholder;
            }
            const selectedOption = options.find(option => option.value === selected);
            return selectedOption ? selectedOption.text : String(selected);
          }}
        >
          <StyledPlaceholderMenuItem disabled>
            {placeholder}
          </StyledPlaceholderMenuItem>
          {options.map(option => (
            <MenuItem key={option.value} value={option.value} sx={StyledMenuItem}>
              <Checkbox checked={value === option.value} sx={StyledCheckbox} />
              <StyledMenuItemText>
                {option.text}
              </StyledMenuItemText>
            </MenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </Box>

  );
};

export default SingleSelect;
